/* eslint-disable jira/filename-case */

import type { CreateUIAnalyticsEvent } from '@atlaskit/analytics-next/types';
import type UIAnalyticsEvent from '@atlaskit/analytics-next/UIAnalyticsEvent';
import {
	fireUIAnalytics,
	fireTrackAnalytics,
	type Attributes,
	fireOperationalAnalytics,
} from '@atlassian/jira-product-analytics-bridge';
import { fireErrorAnalytics } from '@jira/platform__error-reporting/src/fireErrorAnalytics.tsx';
import { ACTION_SUBJECT_ID } from '../../common/constants.tsx';
import { convertTaskIdToActionSubjectId } from '../../common/utils/analytics/index.tsx';

export const fireAnalyticsOnQuickstartClose = (
	analyticsEvent: UIAnalyticsEvent,
	attributes: Attributes,
): void => {
	analyticsEvent.update({ action: 'closed', actionSubject: 'button' });
	fireUIAnalytics(analyticsEvent, 'button closed', ACTION_SUBJECT_ID, attributes);
};

export const fireAnalyticsOnQuickstartDismiss = (
	analyticsEvent: UIAnalyticsEvent,
	attributes: Attributes,
	source: 'checklist' | 'button',
): void => {
	if (source === 'button') {
		fireUIAnalytics(analyticsEvent, 'button clicked', 'dismissQuickstartButton', attributes);
	} else if (source === 'checklist') {
		fireUIAnalytics(analyticsEvent, 'button clicked', 'dismissQuickstart', attributes);
	}
};

export const fireAnalyticsOnQuickstartBack = (analyticsEvent: UIAnalyticsEvent): void => {
	fireUIAnalytics(analyticsEvent, 'button clicked', 'backButton');
};

export const fireAnalyticsOnQuickstartExperienceComplete = (
	createAnalyticsEvent: CreateUIAnalyticsEvent,
	attributes: Attributes,
): void => {
	const analyticsEvent = createAnalyticsEvent({});
	fireTrackAnalytics(analyticsEvent, 'experience completed', ACTION_SUBJECT_ID, {
		...attributes,
	});
};

export const fireAnalyticsOnChecklistItemCompleted = (
	createAnalyticsEvent: CreateUIAnalyticsEvent,
	completedTaskId: string | null,
): void => {
	const analyticsEvent = createAnalyticsEvent({});

	fireTrackAnalytics(
		analyticsEvent,
		'checklistItem completed',
		convertTaskIdToActionSubjectId(completedTaskId),
		{
			taskId: completedTaskId,
		},
	);
};

export const fireAPIErrorAnalytics = (error: Error, endpointSource: string): void => {
	fireErrorAnalytics({
		error,
		meta: {
			id: 'quickstartApiError',
			packageName: 'jiraOnboardingQuickstartCore',
			teamName: 'jlove-makkuro',
		},
		attributes: {
			error: error.message,
			endpointSource,
		},
	});
};

export const fireAnalyticsOnOpenRightHandSidebar = (
	createAnalyticsEvent: CreateUIAnalyticsEvent,
	attributes: Attributes,
): void => {
	const analyticsEvent = createAnalyticsEvent({});
	fireOperationalAnalytics(
		analyticsEvent,
		'nuxOnboardingQuickstart openRightSidebar',
		ACTION_SUBJECT_ID,
		{
			...attributes,
		},
	);
};

export const fireAnalyticsOnMinimiseRightHandSidebar = (
	createAnalyticsEvent: CreateUIAnalyticsEvent,
	attributes: Attributes,
): void => {
	const analyticsEvent = createAnalyticsEvent({});
	fireOperationalAnalytics(
		analyticsEvent,
		'nuxOnboardingQuickstart minimiseRightSidebar',
		ACTION_SUBJECT_ID,
		{
			...attributes,
		},
	);
};
